import React, { useCallback, useEffect, useState, } from "../../../__compat__/react/main.entry.mjs.mjs";
import { format, isValid, parse } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { TextField } from "../../TextField/index.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
const noop = () => { };
export const DateInput = React.forwardRef(({ onBlur = noop, onChange = noop, value: dateValue, inputRef, hint, ...restProps }, ref) => {
    const { datePicker: locale } = useLocale();
    const [localDateValue, setLocalDateValue] = useState(dateValue || null);
    const formattedStringValue = localDateValue
        ? format(localDateValue, locale.format)
        : '';
    const [localStringValue, setLocalStringValue] = useState(formattedStringValue);
    useEffect(() => {
        if (typeof dateValue !== 'undefined' && dateValue !== localDateValue) {
            setLocalDateValue(dateValue);
            setLocalStringValue(dateValue ? format(dateValue, locale.format) : '');
        }
    }, [localDateValue, dateValue, locale.format]);
    const handleChange = useCallback((event) => {
        const nextStringValue = event.currentTarget.value;
        const nextDateValue = parse(nextStringValue, locale.format, new Date());
        if (nextDateValue !== localDateValue) {
            const nextValue = isValid(nextDateValue) ? nextDateValue : null;
            onChange(nextValue, event);
            setLocalDateValue(nextValue);
        }
        setLocalStringValue(nextStringValue);
    }, [locale.format, localDateValue, onChange]);
    const handleBlur = useCallback((event) => {
        onBlur(event);
        if (localDateValue) {
            setLocalStringValue(formattedStringValue);
        }
    }, [onBlur, localDateValue, formattedStringValue]);
    return (React.createElement(TextField, { inputRef: inputRef, ref: ref, onBlur: handleBlur, onChange: handleChange, hint: hint || locale.format.toUpperCase(), value: localStringValue, maxLength: locale.format.length, pattern: locale.pattern.toString(), ...restProps }));
});
DateInput.displayName = 'DateInput';
//# sourceMappingURL=DateInput.mjs.mjs.map